var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addJobComment, deleteJobComment, getAllJobComments, likeJobComment } from '@/api';
import { useMutation } from '@/hooks';
import { useQuery } from '@/hooks/use-query';
import { useCallback, useState } from 'react';
import { SendIcon } from './icons';
import { JobCommentSkeletonList } from './skeleton/job-comment-list-skeleton';
import { Button, Drawer, JobCommentSection, StyledTextField, Text } from './ui';
export var JobCommentsDrawer = function (_a) {
    var isDrawerOpen = _a.isDrawerOpen, onCloseDrawer = _a.onCloseDrawer, jobId = _a.jobId, updateCommentsCount = _a.updateCommentsCount;
    var _b = useState(''), commentText = _b[0], setCommentText = _b[1];
    var queryFnToGetAllJobComments = useCallback(function () { return getAllJobComments(jobId); }, [jobId]);
    var _c = useQuery({
        queryFn: queryFnToGetAllJobComments,
    }), jobComments = _c.data, setJobComments = _c.setData, isJobCommentLoading = _c.isLoading;
    var addJobCommentMutation = useMutation({
        mutationFn: addJobComment,
        onSuccess: function (response, _a) {
            var repliedToCommentId = _a.repliedToCommentId;
            if (repliedToCommentId) {
                setJobComments(function (prevComments) {
                    if (!prevComments)
                        return prevComments;
                    return prevComments.map(function (comment) {
                        if (comment.job_comment_id === repliedToCommentId) {
                            return __assign(__assign({}, comment), { replied_count: comment.replied_count + 1 });
                        }
                        return comment;
                    });
                });
                return;
            }
            updateCommentsCount === null || updateCommentsCount === void 0 ? void 0 : updateCommentsCount(1);
            setJobComments(function (prevComments) { return __spreadArray(__spreadArray([], (prevComments || []), true), (response || []), true); });
            setCommentText('');
        },
        onError: function () {
            setCommentText('');
        },
    }).mutate;
    var likeJobCommentMutation = useMutation({
        mutationFn: likeJobComment,
        onSuccess: function (response, payload) {
            setJobComments(function (prevComments) {
                if (!prevComments)
                    return prevComments;
                return prevComments.map(function (comment) {
                    if (comment.job_comment_id === payload.commentId) {
                        return __assign(__assign({}, comment), { liked_count: payload.liked ? comment.liked_count + 1 : comment.liked_count - 1, comment_liked_by_current_user: payload.liked });
                    }
                    return comment;
                });
            });
        },
    }).mutate;
    var deleteJobCommentMutation = useMutation({
        mutationFn: deleteJobComment,
        onSuccess: function (response) {
            var deletedComment = jobComments === null || jobComments === void 0 ? void 0 : jobComments.find(function (comment) { return comment.job_comment_id === response; });
            if (deletedComment && !(deletedComment === null || deletedComment === void 0 ? void 0 : deletedComment.is_replied_comment)) {
                updateCommentsCount === null || updateCommentsCount === void 0 ? void 0 : updateCommentsCount(-1);
            }
            setJobComments(function (prevComments) {
                if (!prevComments)
                    return prevComments;
                return prevComments.filter(function (comment) { return comment.job_comment_id !== response; });
            });
        },
    }).mutate;
    return (_jsx(Drawer, { title: _jsxs("div", { className: 'flex items-center gap-2 w-full', children: [_jsx(Text, { children: "Comments" }), _jsx("div", { className: 'bg-gray-200 text-gray-600 px-2 py-1 rounded-md text-xs', children: (jobComments === null || jobComments === void 0 ? void 0 : jobComments.length) || 0 })] }), headerClassName: 'pb-0', width: 'w-full sm:w-96', onClose: onCloseDrawer, isClosable: true, isOpen: isDrawerOpen, children: _jsxs("div", { className: 'flex flex-col gap-4 h-full', children: [_jsxs("form", { className: 'flex gap-2 items-end sticky top-10 py-2 bg-white', onSubmit: function (e) {
                        e.preventDefault();
                        addJobCommentMutation({
                            jobId: jobId,
                            comment: commentText,
                        });
                    }, children: [_jsx(StyledTextField, { value: commentText, onChange: function (e) {
                                setCommentText(e.target.value);
                            } }), _jsx(Button, { variant: 'primary', type: 'submit', className: 'rounded-md px-2', disabled: !commentText.trim(), children: _jsx(SendIcon, {}) })] }), _jsx("div", { className: 'flex flex-col gap-2', children: isJobCommentLoading ? (_jsx(JobCommentSkeletonList, {})) : (jobComments === null || jobComments === void 0 ? void 0 : jobComments.map(function (comment) { return (_jsx("div", { className: 'flex gap-2 border-b', children: _jsx(JobCommentSection, { comment: comment, likeJobCommentMutation: likeJobCommentMutation, deleteJobCommentMutation: deleteJobCommentMutation, setJobComments: setJobComments, addJobCommentMutation: addJobCommentMutation }) }, comment.job_comment_id)); })) })] }) }));
};
